// Where a cortex serves what a developer's AI tool uses (ADR 0030), from its public address.

import { MCP_PATH } from '@cortex/access-policy';

/** The one MCP of a person: every project they can open (the path accounts and the assistant serve it at). */
export { MCP_PATH };
/** The Claude Code plugin marketplace this cortex serves (a plain marketplace.json URL). */
export const MARKETPLACE_PATH = '/claude/marketplace.json';
/** Where the plugin's archives are served from. */
export const PLUGIN_ARCHIVE_DIR = '/claude/';

const trim = (base: string) => base.replace(/\/+$/, '');

/** The one MCP's address. */
export const oneMcpUrl = (base: string) => `${trim(base)}${MCP_PATH}`;

/** One project's own MCP address (that project only). */
export const projectMcpUrl = (base: string, org: string, project: string) =>
  `${trim(base)}${MCP_PATH}/${encodeURIComponent(org)}/${encodeURIComponent(project)}`;

/**
 * The query parameter that makes a connection read-only (as Supabase's MCP does): `?read_only=true` on any MCP
 * address. The MCP then offers only the tools that read, whatever the sign-in allows; a person-wide sign-in's
 * project tokens are read-only too, so the api refuses a change as well.
 */
export const READ_ONLY_PARAM = 'read_only';

/** An MCP address as a read-only connection. */
export const readOnlyMcpUrl = (url: string) =>
  `${url}${url.includes('?') ? '&' : '?'}${READ_ONLY_PARAM}=true`;

/** Does a connection's `read_only` value ask for read-only? Any value but `false` / `0` does (a typo never writes). */
export const asksReadOnly = (value: unknown): boolean =>
  value !== undefined && value !== null && !['false', '0'].includes(String(value).trim().toLowerCase());

/** The marketplace's address. */
export const marketplaceUrl = (base: string) => `${trim(base)}${MARKETPLACE_PATH}`;
